import React, { useEffect, useState } from "react";
import axios from "axios";

// const API_BASE = "http://localhost/myapp-ks/api";
const API_BASE = "https://atblogin.cubixsystems.com/myapp/api";

export default function GalleryCategoryManager() {
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  // Fetch categories
  const fetchCategories = async () => {
    const res = await axios.get(`${API_BASE}/fetch_gallery_categories_edit.php`);
    setCategories(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => {
    fetchCategories();
  }, []);   
  
  // Update category
  const updateCategory = async (id) => {
    if (!editName.trim()) {
      alert("Category name cannot be empty");
      return;
    }

    await axios.post(`${API_BASE}/update_gallery_category.php`, {
      id,
      category_name: editName
    });
 window.location.reload();
    setEditId(null);
    fetchCategories();
    
  };

  // Delete category
  const deleteCategory = async (id) => {
    if (!window.confirm("Delete this category permanently?")) return;

    await axios.post(`${API_BASE}/delete_gallery_category.php`, { id });
    fetchCategories();
    window.location.reload();
  };

  return (
    <div style={{ height:'400px',overflow:'auto'}}>
      <h4 style={{fontWeight:'700',fontSize:'14pt'}}>Events</h4>

      <table className="table">
        <thead>
          <tr>
            {/* <th>Event Title</th> */}
            {/* <th>#</th> */}
          </tr>
        </thead>

        <tbody>
          {categories.length === 0 ? (
            <tr>
              <td colSpan="2" align="center">No categories found</td>
            </tr>
          ) : (
            categories.map(cat => (
              <tr key={cat.id}>
                {/* <td>{cat.id}</td> */}

                <td style={{width:'90%'}}>
                  {editId === cat.id ? (
                    <textarea
                      className="form-control" style={{height:'100px'}}
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                    ></textarea>
                  ) : (
                    cat.category_name
                  )}
                    <br />
                  {editId === cat.id ? (
                    <>
                      <button className="btn btn-success" onClick={() => updateCategory(cat.id)}>Save</button>
                      <button className="btn btn-warning" onClick={() => setEditId(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button
                      className="btn btn-primary"
                        onClick={() => {
                          setEditId(cat.id);
                          setEditName(cat.category_name);
                        }}
                      >
                        Edit
                      </button>

                      <button
                      className="btn btn-danger"
                        onClick={() => deleteCategory(cat.id)}
                        style={{ marginLeft: "10px" }}
                      >
                        Delete
                      </button>
                    </>
                  )}
                </td>

                {/* <td>{cat.created_at}</td> */}

                {/* <td style={{width:'10%'}}>
                  {editId === cat.id ? (
                    <>
                      <button onClick={() => updateCategory(cat.id)}>Save</button>
                      <button onClick={() => setEditId(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setEditId(cat.id);
                          setEditName(cat.category_name);
                        }}
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => deleteCategory(cat.id)}
                        style={{ marginLeft: "10px", color: "red" }}
                      >
                        Delete
                      </button>
                    </>
                  )}
                </td> */}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
